// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"36acbc75","456":"661e1b98","477":"0a06f5a7"}[chunkId] + ".chunk.js";
};